/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Glyphicon} from "../../GlyphIcon";
import React from "react";

export function AddItemButton(props) {
    const {
        show = true,
        onAdd = () => {},
        className = '',
    } = props;

    if(!show) { return null; }

    return <div className={['float-right add-table pop-add', className].filter(Boolean).join(' ')}>
            <a className="pndlm-remove-control" onClick={() => onAdd()}>
                <Glyphicon glyph="plus-sign"/>
            </a>
        </div>;
}
